import { Tooltip, Button } from '@ets/design-system';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './ThirdPartyLogin.module.scss';
import { CustomIcon } from '_common/lib/components';
import { getThirdPartyIcon } from 'Auth/consts';

type ThirdPartyLoginProps = {
  data: AuthoritySchemas['ThirdPartyObject'][];
};

const ThirdPartyLogin = ({ data }: ThirdPartyLoginProps) => {
  const intl = useIntl();
  const filteredData = data.filter((thirdParty) => thirdParty.url);
  if (filteredData.length === 0) {
    return null;
  }
  const vertical = filteredData.length <= 2;

  const handleOnClick = (url: string) => {
    window.location.href = url;
  };

  return (
    <div className={!vertical ? styles.horizontal : undefined}>
      {filteredData.map((thirdParty) => (
        <div
          key={thirdParty.name}
          style={vertical ? { marginBottom: '1rem' } : { marginRight: '1rem ' }}
        >
          <Tooltip
            content={intl.formatMessage(
              { id: 'SIGN_IN_WITH' },
              { authenticator: thirdParty.label },
            )}
            placement="bottom"
            visible={!vertical}
            testId="using-thirdParty"
          >
            <Button
              className={styles.thirdPartyButton}
              fullWidth={vertical}
              size="l"
              variant="standard"
              onClick={() => handleOnClick(thirdParty.url)}
              tabIndex={2}
              testId="using-thirdParty"
            >
              <div className={styles.thirdPartyButtonContent}>
                <CustomIcon
                  name={getThirdPartyIcon(thirdParty.label) ?? thirdParty.label}
                  size={32}
                />
                {vertical && (
                  <div style={{ flex: 1 }}>
                    <FormattedMessage
                      id="SIGN_IN_WITH"
                      values={{ authenticator: thirdParty.label }}
                    />
                  </div>
                )}
              </div>
            </Button>
          </Tooltip>
        </div>
      ))}
    </div>
  );
};

export default ThirdPartyLogin;
